// extracted by mini-css-extract-plugin
export default {"wrapper":"Image_wrapper__0LWvU","img":"Image_img__OcODP","fadein":"Image_fadein__h2+QN","skeleton":"Image_skeleton__MpVEk","box":"Image_box__HItVK"};